module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Design/Bucket-7a93928e949a3723bbec426f5e1de4f835b1707e00eb78ac0ece8a07cc2102f1.svg";